module.exports = __webpack_public_path__ + "static/media/section1-brokers.ed2dd11a.svg";